import mock from "../../../fake-db/mock.js"
const data = {
    service: {
        intro: 'Notre approche de services permet à nos clients de réussir leur transformation, d’améliorer leurs performances et de sécuriser au maximum leurs données. ',
        services:[
            {
                delay: 100,
                image: '../../../../images/icon/installation.png',
                title: 'Installation',
                detail: 'Audit et upgrade du parc informatique ; proposition de matériels complémentaires ; installation réseau ; paramétrage de l\'ensemble ; sécurisation informatique.'
            },
            {
                delay: 200,
                image: '../../../../images/icon/formation.png',
                title: 'Formation',
                detail: 'Formation initiale avec des exercices pratiques ; assistance de démarrage d\'exploitation ; formation progressive et avancée pour le personnel. Formation par télé-conférence.'
            },
            {
                delay: 300,
                image: '../../../../images/icon/Assistance.jpg',
                title: 'Assistance',
                detail: 'Conseils et formations ; Dépannage immédiat en cas de panne. Installation de nouveaux matériels ou accessoires ; Prise en compte de vos besoins. Installation des mises à jour. '
            },
            {
                delay: 100,
                image: '../../../../images/icon/ecran-tactile.png',
                title: 'Matériels spécialisés',
                detail: 'Vente de matériels spécialisés : ordinateurs serveurs, afficheurs de prix, écrans tactiles, imprimantes tickets, lecteurs codes-barres, imprimantes codes-barres, tiroirs-caisse...'
            },
        ]
    }
}

mock.onGet("/api/service/all").reply(() => {
    return [200, data.service];
});